module.exports = __webpack_public_path__ + "img/icon_img_15.23c3d3e3.png";